// Static asset path helpers. Centralized so renaming a directory or
// filename pattern is a one-line change.
//
// Parcel serves /static/ at the root, so a file at static/reference/foo.json
// is fetched as /reference/foo.json.

const REFERENCE_DIR = "/reference";
const MARC_DIR = "/marc";
const EGG_DIR = "/eggs";

// Labeled reference JSON for a marc. Flat directory + self-documenting
// filename so a batch of downloads can be drag-dropped into
// static/reference/ from the downloads folder without rename. The
// repetition (`reference/reference-001.json`) is deliberate — the
// filename has to read clearly outside the directory context.
export function referenceFilename(marcId) {
  return `reference-${marcId}.json`;
}
export function referenceUrl(marcId) {
  return `${REFERENCE_DIR}/${referenceFilename(marcId)}`;
}

// Per-marc reference photo. Used by ReferencePhoto (easel), the onion
// overlay in author mode, and saveReference.
export function marcImageUrl(marcId) {
  return `${MARC_DIR}/${marcId}/marc.png`;
}

// Egg photo. There's currently only one egg shared by every marc.
export function eggImageUrl(eggId) {
  return `${EGG_DIR}/${eggId}.png`;
}
